import React from "react";

function Loader({ message = "Loading content...", fullscreen = false }) {
    return (
        <div className={fullscreen ? "fullscreen-loader" : "loader-container"}>
            <div className="loader-spinner"></div>
            <div className="loader-text">{message}</div>
        </div>
    );
}

export default Loader;
